import { styled } from "@mui/material/styles";

const StyledPaymentSuccess = styled("div")(
  ({ theme }) => `
  .payment-success-box {
    background-color: rgba(19, 101, 56, 0.1);
    height: 176px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
      .infoIcon{
  margin-left: 4px;
    width: 12px;
    height: 12px;
  }
  .payment-success-icon-wrap {
    border-radius: 50%;
    background-color: ${theme.palette.customColor.lightGreen};
    width: 100px;
    height: 100px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .payment-success-text-wrap {
    text-align: center;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 30%;
    align-items: center;
    margin: 20px auto;

    @media screen and (max-width: 600px) {
      width: 80%;
    }

  }
   .payment-success-text-header {
     font-family: Lexend;
     font-weight: 500;
     font-size: 32px;
     line-height: 100%;
     color: ${theme.palette.primary.main};
   }
   .payment-success-text-body {
     font-family: Lexend;
     font-weight: 400;
     font-size: 16px;
     line-height: 20px;
     color: ${theme.palette.customColor.secondarySecond};
   }
   .trip-deatails {
     width: 40%;
     margin: 40px auto;
     @media screen and (max-width: 600px) {
       display: none;
     }
   } 
   .trip-title {
     font-family: Lexend;
     font-weight: 400;
     font-size: 18px;
     line-height: 100%;
     color: ${theme.palette.primary.main};
   }
   .info-container-2 {
     margin-top: 10px;
     display: flex;
     flex-direction: column;
     gap: 2px;
   }
    .info-container {
      display: flex;
      gap: 10px;
      align-items: center;
    }
    .arrival-text {
      display: flex;
      gap: 5px;
      align-items: center;
    }
    .bold-text-1 {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .location-text {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
      margin-left: 34px;
    }
    .arrival-text-1 {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.customColor.secondarySecond};
    }
    .arrival-bold-span {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .arrival-text {
      margin-left: 34px;
    }
    .payment-summary {
      width: 40%;
      height: auto;
      background-color: ${theme.palette.customColor.secondaryFirst};
      padding: 16px;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 10px;
      @media screen and (max-width: 600px) {
        display: none;
      }
    }
    .payment-summary-header {
      font-family: Lexend;
      font-weight: 500;
      font-size: 18px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .amount-text {
      font-family: Lexend;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: ${theme.palette.customColor.secondarySecond};
      display: flex;
      align-items: center;
    }
    .amount {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .total-amount-text {
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .total-amount {
      font-family: Lexend;
      font-weight: 500;
      font-size: 16px;
      line-height: 100%;
      color: ${theme.palette.primary.main};
    }
    .amount-container {
      display: flex;
      justify-content: space-between;
      align-items: center;    
    }
    .amount-container-dashed {
      display: flex;
      justify-content: space-between;
      align-items: center; 
      text-decoration: line-through;
    }  
    .button-wrap {
      display: flex;
      flex-direction: column;
      gap: 20px;
      margin: 20px auto;
      width: fit-content;
    }
    .continue-shopping-btn {
      border: 1px solid ${theme.palette.primary.main};
      color: ${theme.palette.primary.main};
      text-transform: none;
      padding: 10px 100px;
      border-radius: 0px;
    }
    .view-planned-trip-btn {
      text-decoration: underline;
      color: ${theme.palette.primary.main};
      text-transform: none;
      font-family: Lexend;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      cursor: pointer;
      text-align: center;
    }       
                                    
    `
);

export default StyledPaymentSuccess;
